import { render } from "./WorldWonder.vue?vue&type=template&id=3dccf8c8"
import script from "./WorldWonder.vue?vue&type=script&lang=js"
export * from "./WorldWonder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/WorldWonder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dccf8c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dccf8c8', __exports__)) {
    api.reload('3dccf8c8', __exports__)
  }
  
  module.hot.accept("./WorldWonder.vue?vue&type=template&id=3dccf8c8", () => {
    api.rerender('3dccf8c8', render)
  })

}


export default __exports__